const baseConfig = {
  show_log: false,
  IS_PERFORMANCE_ANALYTICS_ON: true,
  USE_SENSORS: true, // 使用神策
  is_track_single_page: true, // 默认fasle，表示是否开启单页面自动采集 $pageview 功能，SDK 会在 url 改变之后自动采集web页面浏览事件 $pageview。
  use_client_time: true, // 默认fasle，是否使用客户端时间
  send_type: "image", // 发送数据方式，可选image、ajax、beacon，默认 image
  heatmap: {}, // 点击图配置. 参考 https://manual.sensorsdata.cn/sa/latest/tech_sdk_client_web_all_use-34537687.html
};
const sitConfig = {
  // server_url: "https://ubs.sf-express.com/sa?project=gjdsgrey",
  server_url: "https://ubs-access-tst.sf-express.com/sa?project=gjdsgrey",
};
const proConfig = {
  server_url: "https://ubs.sf-express.com/sa?project=gjds",
};
export const initConfig =
  process.env.NODE_ENV === "prd"
    ? Object.assign({}, baseConfig, proConfig)
    : Object.assign({}, baseConfig, sitConfig);
